// extracted by mini-css-extract-plugin
export var stepActive = "_2l-3";
export var stepCompleted = "_2l-4";
export var stepConnectorLine = "_2l-b";
export var stepIndicatorCircle = "_2l-6";
export var stepIndicatorCircleCompleted = "_2l-7";
export var stepIndicatorCircleDefault = "_2l-8";
export var stepIndicatorTextCompleted = "_2l-9";
export var stepIndicatorTextDefault = "_2l-a";
export var stepPending = "_2l-5";
export var wizardContainer = "_2l-1";
export var wizardContent = "_2l-2";
export var wizardModal = "_2l-0";